module.exports = __webpack_public_path__ + "img/4.658f9475.png";